import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"rounded-lg"},[_vm._t("header"),_c('apexchart',{attrs:{"type":"radialBar","height":_vm.height,"width":_vm.width,"options":_vm.chartOptions,"series":_vm.limitedSeries}}),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }